import Vue from 'vue';
import Vuex from 'vuex';
import AuthModule from '@/use-cases/user-auth/AuthModule';
import SignUpModule from '@/use-cases/user-signup/SignUpModule';
import ManageUsersModule from '@/use-cases/manage-users/ManageUsersModule';
import RedMatCalculationModule from '@/use-cases/red-mat-calculation/RedMatCalculationModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: AuthModule,
    signup: SignUpModule,
    users: ManageUsersModule,
    redMatCalculation: RedMatCalculationModule,
  },
});
